import { call, put, takeLatest } from "redux-saga/effects"

import { GET_ANSWER_FROM_QUERY } from "./actionTypes"

import {
    getAnswerFromQuerySuccess,
    getAnswerFromQueryError,
} from "./actions"

import {
    genericPostRequest
} from "../../helpers/sf_backend_helper"

import { AppConfiguration } from "config"

function* onGetAnswerFromQuery(action) {
    try {
        let user = JSON.parse(localStorage.getItem("authUser")).user
        const response = yield call(
            genericPostRequest,
            `${AppConfiguration.BACKEND_URL}/api/v1/quote_call_ai`,
            {
                body: JSON.stringify(action?.payload),
                headers: {
                    Authorization: user.token,
                    'account-id': user.account_id,
                    'Content-Type': 'application/json',
                }
            }
        )
        yield put(getAnswerFromQuerySuccess(response))
    } catch (error) {
        yield put(getAnswerFromQueryError(error))
    }
}

function* AnswerFromQuerySaga() {
    yield takeLatest(GET_ANSWER_FROM_QUERY, onGetAnswerFromQuery)
}

export default AnswerFromQuerySaga

